module.exports = `${require.publicPath}about-img01.7d091486.png`;